import { render } from "./CoreScanner.vue?vue&type=template&id=078da5ac&scoped=true"
import script from "./CoreScanner.vue?vue&type=script&lang=js"
export * from "./CoreScanner.vue?vue&type=script&lang=js"

import "./CoreScanner.vue?vue&type=style&index=0&id=078da5ac&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078da5ac"]])

export default __exports__